import { AppLink } from '@/shared/components/AppLink';

interface BreadcrumbItem {
  name: string;
  url: string | null;
}

interface PdpBreadCrumbsProps {
  schema: string;
}

function parseBreadcrumbs(schema: string): BreadcrumbItem[] {
  try {
    const parsed = JSON.parse(schema) as {
      itemListElement?: Array<{ item?: { name?: string; '@id'?: string } }>;
    };
    return (parsed.itemListElement ?? []).map((el) => ({
      name: el.item?.name ?? '',
      url: el.item?.['@id'] ?? null,
    }));
  } catch {
    return [];
  }
}

export function PdpBreadCrumbs({ schema }: PdpBreadCrumbsProps) {
  const items = parseBreadcrumbs(schema);
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-[11px] font-normal uppercase tracking-wider text-gray-500 md:text-xs">
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-1">
        {items.map((item, index) => (
          <li key={`${item.name}-${index}`} className="inline-flex items-center gap-x-1">
            {index > 0 && (
              <span className="px-1 text-gray-400" aria-hidden>
                /
              </span>
            )}
            {item.url ? (
              <AppLink to={item.url} showScreenLoader className="hover:text-gray-700">
                {item.name}
              </AppLink>
            ) : (
              <span className="text-gray-600">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
